@if (organizationModules$ | async; as organizationModules) {
  @if (modules$ | async; as modules) {
    <div class="modules-container">
      @for (module of modules; track module.id) {
        <mat-slide-toggle
          color="primary"
          class="margin--bottom-l"
          [checked]="organizationModules.moduleIds.includes(module.id)"
          (toggleChange)="toggleModuleForOrganization(module.id, organizationModules.moduleIds.includes(module.id))">
          {{ module.name }}
        </mat-slide-toggle>
      }
    </div>
  }
}

<button mat-raised-button class="margin--top-s" color="primary" (click)="skipStep.emit()">Tilknyt portalbrugere</button>
